module.exports = __webpack_public_path__ + "static/media/start_call.b8a75d42.png";